import { useContext, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { logClick, logPageView } from '../../core/services/ActivityService';
import AppContext from '../../core/stores/AppContext';

/**
 * Sends wizard page views and click events to the activity API so
 * authenticated user + step can be queried with other API logs.
 */
const ActivityTracker = () => {
    const location = useLocation();
    const lastPath = useRef(null);
    const appContext = useContext(AppContext);

    useEffect(() => {
        const path = `${location.pathname}${location.search || ''}`;
        if (lastPath.current === path) {
            return;
        }
        lastPath.current = path;
        logPageView(location.pathname);
    }, [location.pathname, location.search, appContext]);

    useEffect(() => {
        const onClick = (event) => logClick(event);
        document.addEventListener('click', onClick, true);
        return () => document.removeEventListener('click', onClick, true);
    }, []);

    return null;
};

export default ActivityTracker;
